import { Controller } from "stimulus"

// #1732: velden in het detailpaneel slaan zichzelf op zodra je een veld
// verlaat of een keuze maakt (sectie 31). Het antwoord tekent het paneel
// opnieuw; het veld dat daarna de focus had, krijgt die terug.
let terugNaar = null

document.addEventListener("turbo:before-stream-render", (event) => {
  if (!terugNaar || event.target.getAttribute("target") !== "sl_paneel") return
  const origineel = event.detail.render
  const id = terugNaar
  terugNaar = null
  event.detail.render = async (element) => {
    await origineel(element)
    const veld = id && document.getElementById(id)
    if (veld && typeof veld.focus === "function") veld.focus({ preventScroll: true })
  }
})

export default class extends Controller {
  static targets = ["status"]

  connect() {
    this.klaar = () => { delete this.element.dataset.slBezig }
    this.element.addEventListener("turbo:submit-end", this.klaar)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.klaar)
    clearTimeout(this.timer)
  }

  bewaar(event) {
    const veld = event.target
    if (!veld || !veld.form || veld.type === "file") return
    // #1732 vervolg: zolang dit staat, wacht het sluiten van het venster op het antwoord
    this.element.dataset.slBezig = "1"
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      const actief = document.activeElement
      terugNaar = actief && actief.id && actief !== veld ? actief.id : null
      if (this.hasStatusTarget) this.statusTarget.textContent = "…"
      this.element.requestSubmit()
    }, 120)
  }
}
